import { useLocation } from 'react-router-dom';
import { useInputBindingPress } from '@sorrem-client/ui/hooks';
import { getStoredSessionToken, getStoredAccountId } from '@sorrem-client/ui/shared/auth-session';
import { useDeveloperSnapshot } from './use-developer-snapshot';

function SnapshotKeyBindings(): null {
    const { isAvailable, takeSnapshot, takeCleanRender } = useDeveloperSnapshot();
    useInputBindingPress('take-snapshot', isAvailable ? takeSnapshot : undefined);
    useInputBindingPress('take-clean-render', isAvailable ? takeCleanRender : undefined);
    return null;
}

/**
 * The snapshot keys (F9, Shift+F9), on every page, for developers only
 * (#303). Signed out there is no role to ask about, so nothing is bound;
 * the stored session is checked again on each navigation, which is how a
 * login arrives.
 */
export function DeveloperSnapshotKeys(): JSX.Element | null {
    useLocation();
    const hasStoredSession = getStoredAccountId() !== null && getStoredSessionToken() !== null;
    return hasStoredSession ? <SnapshotKeyBindings /> : null;
}
